import { useNavigate } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import { PageHeader } from "Components/Public/PageHeader/PageHeader";
import { COMMON_FORMATS_CARDS_DATA } from "./CommonFormatsCardData";
import CommonFormatCard from "./CommonFormatCard";
import Feedback from "../../../Components/Public/Feedback/Feedback";
import { TextButton, IconTextButton } from "Components/Button";
import { PublicAccordion } from "Components/Public/Accordion/PublicAccordion";
import { NextPage } from "Components/Public/NextPage/NextPage";
import { PATHS } from "Utils/PagePaths";
import { ICONS } from "Utils/icons";
import { MailOutlined } from "@mui/icons-material";
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";


const UseCommonFormats = () => {

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    if (path) {
      navigate(path);
    }
  }

  return (
    <>
      <ReCaptchaWrapper
        action="use_common_formats_landing"
        title="Current Common Formats"
      >
        <Row className="justify-content-center m-0 p-0">
          <PageHeader
            title="Current Common Formats"
            intro="The Agency for Healthcare Research and Quality (AHRQ) coordinates the development of Common Formats for reporting and analysis of patient safety data. A major goal is to allow aggregation of data to identify and address underlying causal factors affecting patient safety and quality."
          >
            <h2 className="public-title text-center mb-3">Why use the Common Formats?</h2>
            <Row className="blue-text public-cards col-gap2 row-gap-3">
              <Col className="" lg={6}>
                <Card className="h-100">
                  <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                    <div className="number-bg align-items-center">
                      <div className="mb-1"><span className="displayXS semibold">1</span></div>
                    </div>
                    <div className="">
                      <div className="text-start mb-2"><span className="public-card-header horizontal header2">Collect the Right Data</span></div>
                      <div className="public-card-content ">
                        <p>Common Formats are created in collaboration with government agencies and the private sector to arrive at a set of best practices for collecting patient safety data.</p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col className="" lg={6}>
                <Card className="h-100">
                  <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                    <div className="number-bg align-items-center">
                      <div className="mb-1"><span className="displayXS semibold">2</span></div>
                    </div>
                    <div>
                      <div className="text-start mb-2"><span className="public-card-header horizontal header2">Submit Data for National Learning</span></div>
                      <div className="public-card-content ">
                        <p>PSOs use Common Formats to submit structured and unstructured data from across the country. AHRQ then uses AI and statistical analysis techniques to advance learning, such as identifying causal factors.</p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </PageHeader>
          <Row className="main-content m-0 mt-5 pt-4 d-flex justify-content-center g-0">
            <Col lg="10" xs="10" id={"current-common-formats"}>
              <h3>
                Common Formats
              </h3>
            </Col>
          </Row>
          {COMMON_FORMATS_CARDS_DATA.map((item, index) => {
            return (
              <CommonFormatCard data={item}></CommonFormatCard>)
          })}
        </Row>
  
        <Feedback/>
  
        {/* <Row className="justify-content-center m-0 p-0">

          <div className="pf-common-formats-header m-0 px-3">
            <Col className="ms-auto me-auto justify-content-center" md={8} lg={7} id="common-formats-feedback">
              <h2 className="pf-common-formats-title text-center displayS mb-3">Provide Feedback on the Common Formats</h2>
              <p className="body pf-common-formats-intro text-center mb-4">

                We are actively enhancing the Common Formats Commenting Tool . In the meantime, your feedback remains important. Help us ensure the
                Common Formats are meeting your needs. Your real-world input and perspective are essential for the PSOPPC and our Expert Panel to
                recommend updates or new formats to AHRQ. Contact PSOPPC support via <a href={`mailto:support@psoppc.org`}>support@psoppc.org</a>&nbsp;
                today to provide your feedback.
              </p>
              <div className="d-flex justify-content-center">
                <IconTextButton
                  className="reverse  d-flex justify-content-center w-xs-100 w-md-fit-content"
                  icon={ICONS.mailoutlined}
                  onClick={() => window.location = "mailto:support@psoppc.org"}
                  variant="comp-outline-clear"
                  size="lg-pl"
                  content={"Contact Us"}
                />
              </div>
            </Col>
          </div>
        </Row> */}
        <Row className="justify-content-center m-0 p-0">
          <div className="use-retired-common-formats-header m-0 px-3">
            <Col className="ms-auto me-auto" md={8} lg={7} >
              <h2 className="retired-common-formats-title text-center displayS mb-3">Retired Common Formats</h2>
              <p className="body retired-common-formats-intro text-center mb-4">Retired Common Formats are no longer active for reporting and should be utilized for reference purposes only.</p>
              <TextButton
                variant={"comp-outline-clear"}
                onClick={() => handleNavigate(PATHS.public["Retired Common Formats"])}
                content={"View Retired Common Formats"}
                className="w-xs-100 w-md-fit-content"
                size="lg-pl"
              />
            </Col>
          </div>
        </Row>
        <Row className="faq m-0 d-flex justify-content-center">
          <Col lg="10">
            <h2 className="mb-5">Frequently Asked Questions</h2>
            <PublicAccordion
              defaultActiveKey={[]}
              accordionItemsContent={[
  
                {
                  header: "What are Common Formats?",
                  content: () => {
                    return (
                      <>
                        <p className="mb-0">
                          AHRQ's Common Formats are a set of standardized definitions and formats that make it possible to collect,
                          aggregate, and analyze uniformly structured information about patient safety for local, regional,
                          and national learning. They have been developed for use by healthcare providers that choose to work with
                          patient safety organizations (PSOs) listed by AHRQ under the Patient Safety and Quality Improvement Act
                          of 2005 (Patient Safety Act). The Common Formats are also available in the public domain to encourage
                          their widespread adoption. An entity does not need to be listed as a PSO or working with one to use the
                          Common Formats. However, the Federal privilege and confidentiality protections only apply to information
                          developed as patient safety work product by providers and PSOs working under the Patient Safety Act.
                        </p>
                        <p>
                          AHRQ has developed Common Formats for Event Reporting for several healthcare settings and event types.
                          AHRQ has also developed Common Formats for Surveillance and continues to work on developing new Common
                          Formats.
                        </p>
                      </>
                    )
                  }
                },
                {
                  header: "Why we use Common Formats?",
                  content: () => {
                    return (
                      <>
                        <p className="mb-0">
                          PSOs are required to collect and analyze patient safety work product in a standardized manner to the
                          extent practical and appropriate, to permit valid comparisons of similar cases among similar providers.
                          Using the AHRQ Common Formats (common definitions and reporting formats) makes it possible to collect,
                          aggregate, and analyze uniformly structured information about patient safety for local, regional, and
                          national learning.
                        </p>
                      </>
                    )
                  }
                },
                {
                  header: "What are the Common Formats for Event Reporting (CFER)?",
                  content: () => {
                    return (
                      <>
                        <p className="mb-0">
                          Generally, the CFER can be used for:
                        </p>
                        <ul className="accordion-list-style">
                          <li>Incidents: patient safety events that reached the patient, whether or not there was harm involved.</li>
                          <li>Near misses (or close calls): patient safety events that did not reach the patient.</li>
                          <li>Unsafe conditions: circumstances that increase the probability of a patient safety event occurring.</li>
                        </ul>
                        <p>
                          Currently, there are CFER that include several event-specific modules for hospitals (CFER-H) and nursing
                          homes (CFER-NH). There is also a CFER designed for community pharmacies (CFER-CP) and a CFER for
                          diagnostic safety (CFER-DS) designed for use in any healthcare setting.
                        </p>
                      </>
                    )
                  }
                },
                {
                  header: "What are the Common Formats for Surveillance?",
                  content: () => {
                    return (
                      <>
                        <p className="mb-0">
                          The Common Formats for Surveillance - Hospital (CFS-H) is a set of event descriptions defined for the
                          retrospective review of medical records to identify whether certain patient safety events occurred.
                          This Common Formats is designed to provide information that is complementary to that derived from event
                          reporting systems. The term "surveillance" in this context refers to the improved detection of events and
                          calculation of adverse event rates in populations reviewed that will facilitate collection of comparable
                          performance data over time and across populations of patients. Common Formats for
                          Surveillance - Hospital V1.0 (CFS-H), which includes event descriptions, is currently available for public
                          review and comment. The structured modules contained in the Surveillance version are operationalized in
                          AHRQ's Quality and Safety Review System (QSRS).
                        </p>
                      </>
                    )
                  }
                },
                {
                  header: "What are the most current Common Formats?",
                  content: () => {
                    return (
                      <>
                        <p className="mb-0">
                          The following Common Formats versions are active and available for implementation and use by
                          healthcare providers and PSOs:
                        </p>
                        <ul className="accordion-list-style">
                          <li>Common Formats for Event Reporting - Community Pharmacy Version 1.0</li>
                          <li>Common Formats for Event Reporting - Diagnostic Safety Version 1.0</li>
                          <li>Common Formats for Event Reporting - Hospital Version 1.2</li>
                          <li>Common Formats for Event Reporting - Hospital Version 2.0</li>
                          <li>Common Formats for Event Reporting - Nursing Home Version 1.0</li>
                        </ul>
                        <p className="mb-0">
                          PSOs may send data from these versions to the PSOPPC for de-identification and submission to the Network
                          of Patient Safety Databases (NPSD). CFER-DS V1.0, released in May 2022, is the first version of
                          Common Formats for Diagnostic Safety. Providers and PSOs can begin use of it at any time.
                        </p>
                      </>
                    )
                  }
                },
                {
                  header: "How can I provide feedback on the Common Formats?",
                  content: () => {
                    return (
                      <>
                        <p className="mb-0">
                          Development of the Common Formats is an ongoing process. AHRQ welcomes feedback, especially from all
                          users, to improve the current Common Formats and inform the development of new types of Common Formats.
                          Any comments on the Common Formats versions that are active for reporting can be submitted through the
                          Common Formats Commenting Tool.
                        </p>
                      </>
                    )
                  }
                },
                {
                  header: "What is included in the AHRQ Common Formats?",
                  content: () => {
                    return (
                      <>
                        <p className="mb-0">
                          The final set of Common Formats include:
                        </p>
                        <ul className="accordion-list-style">
                          <li>Users Guide</li>
                          <li>Event Descriptions</li>
                          <li>Forms (only available for some Common Formats and versions)</li>
                          <li>CDA XML File Samples</li>
                          <li>A Data Dictionary which defines the data elements</li>
                          <li>A Clinical Document Architecture Implementation Guide, which shows how to enable electronic transmission of the Common Formats data</li>
                          <li>The Validation Rules and Errors Guide; Common Format Flow Charts; and specifications for processing, linking and reporting on events</li>
                          <li>A Metadata registry with data element attributes and technical specifications for use by developers.</li>
                        </ul>
                        <p className="mb-0">
                          PSOs may send data from these versions to the PSOPPC for de-identification and submission to the Network
                          of Patient Safety Databases (NPSD). CFER-DS V1.0, released in May 2022, is the first version of
                          Common Formats for Diagnostic Safety. Providers and PSOs can begin use of it at any time.
                        </p>
                      </>
                    )
                  }
                }
              ]}
            ></PublicAccordion>
          </Col>
        </Row>
       </ReCaptchaWrapper>
      <NextPage path={PATHS.public['Submit Data']} text="Submit Data"
        backPath={PATHS.public['Become a PSO']} backPathText="Become a PSO"
      ></NextPage>

    </>
  )
}

export default UseCommonFormats;